export default __webpack_public_path__ + "static/media/customer.9c592fda.svg";